import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import type { TimeoutRow } from '@sportninja/common/features/game/scoring/types/timeout'
import {
  setTimeoutCount,
  type TimeoutCountInput,
} from '@sportninja/common/services/game/timeoutCountService'

/**
 * Sets how many timeouts a team called in a period of a basic-stats game, from
 * the web's Edit Timeline.
 *
 * The game's cached entries are invalidated rather than patched: the API
 * decides which timeouts it records or removes. The timeline reloads its own
 * copy of the game after every edit, as it does for points and shots.
 */
export const useSetTimeoutCount = () => {
  const queryClient = useQueryClient()

  return useMutation<TimeoutRow[], Error, TimeoutCountInput>({
    mutationFn: setTimeoutCount,
    // The sheet shows a refusal straight away, and saving the same count again
    // is safe. `req` already retries a request that never got an answer.
    retry: 0,
    onSuccess: (_rows, { gameId }) =>
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.game.all, gameId],
      }),
  })
}
